/**
 *  @class
 *  @function ImageTextOverlay
 */

if (!customElements.get('image-with-text-overlay')) {
  class ImageTextOverlay extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }
    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }
    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        if (this.tl) {
          this.tl.kill();
        }
        if (this.splittext) {
          this.splittext.revert();
        }
      }
    }
    prepareAnimations() {
      let section = this,
        button_offset = 0,
        property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      // Text fades up piece by piece (CSS, see lococo-motion.css), same motion as the homepage hero.
      const subheading = section.querySelector('.subheading');
      if (subheading) subheading.style.setProperty('--lm-to', '0.6');
      window.lococoReveal && window.lococoReveal([
        subheading,
        section.querySelector('.image-with-text-overlay--heading'),
        ...section.querySelectorAll('.rte p'),
        ...section.querySelectorAll('.button')
      ], section);

      let parallaxImage = section.querySelector('.thb-parallax-image');
      if (parallaxImage && CSS.supports('animation-timeline: view()')) {
        section.querySelectorAll('.thb-parallax-image').forEach((img) => img.classList.add('lm-parallax'));
      } else if (parallaxImage) {
        gsap.fromTo(parallaxImage, {
          y: '-8%'
        }, {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            scrub: 1,
            start: () => `top bottom`,
            end: () => `bottom top+=${property}`,
            onUpdate: () => {
              property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
            }
          }
        });
      }
    }
  }
  customElements.define('image-with-text-overlay', ImageTextOverlay);
}
